<template>
  <div class="automate allot-rule">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        班次规则
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click.native="doNew">新增班次规则</el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="班次规则" :visible.sync="openDetail" width="700px">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      >
        <template slot="conditions">
          <el-form-item>
            <el-tag type="success" size="medium">多条件均满足时规则生效</el-tag>
          </el-form-item>
          <el-form-item v-for="(condition, index) of formData.conditions" :key="index">
            <div>条件{{ index + 1 }}</div>
            <div class="condition-card">
              <el-card shadow="hover">
                <el-form-item label="分单条件">
                  <el-select
                    v-model="formData.conditions[index].type"
                    placeholder="请选择"
                    @change="
                      formData.conditions[index].value = '';
                      getOptions(formData.conditions[index].type);
                    "
                    clearable
                  >
                    <el-option
                      v-for="item in options.allotType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!--按省市区-->
                <el-form-item
                  v-if="formData.conditions[index].type == 'area'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                  prop="area"
                >
                  <el-cascader
                    :props="area.props"
                    :options="area.options"
                    v-model="formData.conditions[index].value"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按服务区域-->
                <el-form-item
                  v-else-if="formData.conditions[index].type == 'serviceTerritory'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-select
                    v-model="formData.conditions[index].value"
                    multiple
                    filterable
                    remote
                    reserve-keyword
                    placeholder="可搜索服务区域"
                    :remote-method="getST"
                    @change="$forceUpdate()"
                    clearable
                  >
                    <el-option
                      v-for="item in options.serviceTerritory"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!--按渗漏部位-->
                <el-form-item
                  v-else-if="formData.conditions[index].type == 'exts.leakagesite_copy'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.repairParts"
                    :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按信息渠道-->
                <el-form-item
                  v-else-if="formData.conditions[index].type == 'channel'"
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.channel"
                    :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按其他 档案字段-->
                <el-form-item
                  v-else
                  :label="'按' + osg.codelabel('allotType', formData.conditions[index].type)"
                >
                  <el-select v-model="formData.conditions[index].value" multiple clearable>
                    <el-option
                      v-for="item in options[formData.conditions[index].type]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <div class="card-remove">
                <i class="el-icon-remove" @click="removeCondition(index)"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button plain icon="el-icon-plus" class="button_dashed" @click="newCondition">
              新增条件
            </el-button>
          </el-form-item>
        </template>
        <template slot="dispatchShiftId">
          <el-select
            v-model="formData.dispatchShiftId"
            filterable
            clearable
            @clear="formData.dispatchShiftName = ''"
          >
            <template v-for="(item, i) in options.shift">
              <el-option
                v-if="item.type == 1"
                :key="i"
                :label="item.name"
                :value="item._id"
                @click.native="shiftClick('dispatchShiftName', item.name)"
              ></el-option>
            </template>
          </el-select>
        </template>
        <template slot="supervisorShiftId">
          <el-select
            v-model="formData.supervisorShiftId"
            filterable
            clearable
            @clear="formData.supervisorShiftName = ''"
          >
            <template v-for="(item, i) in options.shift">
              <el-option
                v-if="item.type == 2"
                :key="i"
                :label="item.name"
                :value="item._id"
                @click.native="shiftClick('supervisorShiftName', item.name)"
              ></el-option>
            </template>
          </el-select>
        </template>
        <template slot="headmanShiftId">
          <el-select
            v-model="formData.headmanShiftId"
            filterable
            clearable
            @clear="formData.headmanShiftName = ''"
          >
            <template v-for="(item, i) in options.shift">
              <el-option
                v-if="item.type == 3"
                :key="i"
                :label="item.name"
                :value="item._id"
                @click.native="shiftClick('headmanShiftName', item.name)"
              ></el-option>
            </template>
          </el-select>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'shiftRule',
  data() {
    window.$this = this;
    return {
      name: 'shiftRule',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        conditions: [{ type: 'serviceTerritory', value: [] }],
        exts: {}
      },
      rules: this.$util.rules,
      options: {
        codecfg_regions: { codeId: 'regions' },
        codecfg_allotType: { codeId: 'ALLOTTYPE' },
        serviceTerritory: [],
        cascadeCode_repairParts: [],
        cascadeCode_channel: [],
        allScoreCalcRules: [],
        scoreCalcRules: [],
        shift: [] // 工作班次
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('shiftRule', () => {
      this.osg.getFpi();
      this.getData();
    });
    this.getST();
    this.getShift();
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        conditions: [{ type: 'serviceTerritory', value: [] }],
        exts: {}
      };
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        'regex:name|string#or': this.searchValue
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/shiftRule/query.do', params, res => {
        res.data.map(item => {
          item.exts = item.exts || {};
        });
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs.form &&
          this.$refs.form.$refs.formData &&
          this.$refs.form.$refs.formData.clearValidate();
      });
    },
    doEdit(row) {
      this.formData = this.$util.deepCopy(row);
      for (let condition of row.conditions) {
        this.getOptions(condition.type);
      }
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        if (
          !this.formData.dispatchShiftId &&
          !this.formData.supervisorShiftId &&
          !this.formData.headmanShiftId
        ) {
          this.osg.toast('请至少选择1个班次', 'warning');
          return;
        }
        this.osg.ajax('basic/shiftRule/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.osg.toast('保存成功');
          this.doInit();
          this.getData();
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/shiftRule/enable.do', { id }, () => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/shiftRule/disable.do', { id }, () => {
        this.osg.toast('禁用成功');
        this.getData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/shiftRule/delete.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    //新增条件
    newCondition() {
      this.formData.conditions.push({
        type: 'serviceTerritory',
        value: ''
      });
    },
    //删除条件
    removeCondition(index) {
      this.formData.conditions.splice(index, 1);
    },
    //获取字典表
    getOptions(type) {
      if (type != 'area' && type != 'serviceTerritory' && type != 'channel') {
        this.options['codecfg_' + type] = {
          codeId: type.indexOf('exts.') != -1 ? type.split('.')[1] : type
        };
        this.osg.codeoption(() => {
          this.$forceUpdate();
        });
      }
    },
    //获取服务区域
    getST(query) {
      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'regex:name|string#or': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 获取工作班次
    getShift() {
      this.osg.ajax(
        'basic/shift/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.options.shift = res.data;
        }
      );
    },
    // 选择班次冗余存储名称
    shiftClick(fieldName, name) {
      this.formData[fieldName] = name;
    }
  }
};
</script>
<style>
.condition-card {
  display: flex;
  justify-content: space-between;
}
.condition-card .el-card {
  width: 90% !important;
}
.condition-card .card-remove {
  width: 10%;
  text-align: center;
  color: #f2795b;
  cursor: pointer;
  font-size: 18px;
}
.automate .el-dialog__body {
  padding: 20px 30px;
}
.allot-rule .el-dialog__body {
  padding: 20px 30px !important;
}
</style>
